// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"78b0d817","874":"f710fb9d"}[chunkId] + ".chunk.js";
};